var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMediumPriority = function SvgMediumPriority(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4714 3.52925C8.21106 3.2689 7.78894 3.2689 7.5286 3.52925L4.19526 6.86258C3.93491 7.12293 3.93491 7.54504 4.19526 7.80539C4.45561 8.06574 4.87772 8.06574 5.13807 7.80539L8 4.94346L10.8619 7.80539C11.1223 8.06574 11.5444 8.06574 11.8047 7.80539C12.0651 7.54504 12.0651 7.12293 11.8047 6.86258L8.4714 3.52925Z",
    fill: "#FF8F27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4714 8.19591C8.21105 7.93556 7.78894 7.93556 7.5286 8.19591L4.19526 11.5292C3.93491 11.7896 3.93491 12.2117 4.19526 12.4721C4.45561 12.7324 4.87772 12.7324 5.13807 12.4721L8 9.61013L10.8619 12.4721C11.1223 12.7324 11.5444 12.7324 11.8047 12.4721C12.0651 12.2117 12.0651 11.7896 11.8047 11.5292L8.4714 8.19591Z",
    fill: "#FF8F27"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMediumPriority);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "medium-priority.d200b3e50d2bffa9e77338d62295f594.svg";